export type IdsEcoaRow = {
  guid: string;
  idRegra: string;
  nomePromocao: string;
  mesReferencia: string | number | null;
  anoReferencia: string | number | null;
};

export type IdsEcoaColumn = {
  key: keyof Omit<IdsEcoaRow, 'guid'>;
  label: string;
  type?: 'text' | 'month' | 'year';
  required?: boolean;
};

export type ValidationError = {
  row: number;
  field: string;
  message: string;
};

export type IdsEcoaSkippedRow = {
  row: number;
  idRegra?: string;
  nomePromocao?: string;
  mesReferencia?: string | number | null;
  anoReferencia?: string | number | null;
  reason: string;
};

export type SaveResponse = {
  success: boolean;
  error?: string;
  validationErrors?: ValidationError[];
  data?: {
    columns: IdsEcoaColumn[];
    rows: IdsEcoaRow[];
    updated_at?: string | null;
  };
  changedCount?: number;
  skippedCount?: number;
  skippedRows?: IdsEcoaSkippedRow[];
  historySaved?: boolean;
};

export type HistoryFieldChange = {
  field: string;
  label: string;
  before: string | number | null;
  after: string | number | null;
};

export type HistoryChange = {
  action: 'insert' | 'update' | 'delete';
  guid: string;
  idRegra: string;
  fields: HistoryFieldChange[];
};

export type HistoryEntry = {
  id_log: number;
  log_name?: string;
  name: string;
  email: string;
  created_at: string;
  data: {
    action?: string;
    source?: string;
    total_changed?: number;
    total_skipped?: number;
    changes?: HistoryChange[];
    skipped?: IdsEcoaSkippedRow[];
  };
};

export const IDS_ECOA_COLUMNS: IdsEcoaColumn[] = [
  { key: 'idRegra', label: 'ID Regra', required: true },
  { key: 'nomePromocao', label: 'Nome Promoção', required: true },
  { key: 'mesReferencia', label: 'Mês Referência', type: 'month', required: true },
  { key: 'anoReferencia', label: 'Ano Referência', type: 'year' },
];
